export function toBase64(file: File): Promise<string> {
  const reader = new FileReader()

  return new Promise((resolve, reject) => {
    reader.onload = () => {
      if (typeof reader.result !== 'string') {
        reject(new Error('Failed to read the file'))
        return
      }

      resolve(reader.result.substring(reader.result.indexOf(',') + 1))
    }
    reader.onerror = () => reject(reader.error ?? new Error('Failed to read the file'))

    reader.readAsDataURL(file)
  })
}
